<script>
export default {
  props: {
    value: Object,
  },
}
</script>

<template>
  <i18n :path="value.event" tag="div">
    <template #file>
      <a :href="value.data.url" target="_blank">{{ value.data.name }}</a>
    </template>
  </i18n>
</template>
